import styled from 'styled-components';

export const OrderGroupHeading = styled.div`
  display: grid;
  grid-template-columns: 40px 1fr;
  gap: 10px;
  width: 100%;
  padding: 10px 0;
  margin-top: 10px;
  font-weight: 600;
`;

export const SpaOrderGroupText = styled.div`
  width: 100%;
  font-weight: 400;
  font-size: 14px;
  color: ${({ theme }) => theme.greyColors['grey-60']};
  padding-top: 10px;
`;
